import type { MarkerSelectionState, MapAccessibilityTexts } from "../map/types";
import { getMarkerAccessibilityLabel } from "../../utils/label";
import { t } from "@ebay/i18n-ebay";
export interface Input {
  amount: number;
  animationDelay: number;
  selectionState: MarkerSelectionState;
  mapAccessibilityTexts?: MapAccessibilityTexts;
}
$ const accessibilityLabel = getMarkerAccessibilityLabel({
  mapAccessibilityTexts: input.mapAccessibilityTexts,
  contentKey: "clusterListings",
  itemsTotal: input.amount,
});

<div
  class=["map-cluster map-component-with-tooltip", input.selectionState]
  style={ "animation-delay": ` ${input.animationDelay}s;` }
  aria-label=accessibilityLabel
>
  <span class="map-component-tooltip">
    ${t("mapview/map", "clusterTooltipLabel", { count: input.amount })}
  </span>
  <span>${input.amount}</span>
</div>
